import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import AdminLogin from './pages/AdminLogin';

/**
 * Esqueleto. Hoy son dos rutas y nada más: la landing y el lugar donde va a ir el
 * login de admin. Está así a propósito — el objetivo de esta etapa era dejar el
 * deploy andando, no el frontend hecho.
 *
 * Cuando exista el login de verdad, /admin queda detrás de una ruta protegida.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
